import styled from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import { BRAND_LIBRARY_DARK_TEXT_COLOR, BRAND_LIBRARY_BODY_TEXT } from 'common/constants/brandLibrary';

import TextParagraph from '../TextParagraph';

const Paragraph = styled(TextParagraph)`
    padding: 0;

    ${mediaMaxWidth.medium`
        padding: 0;
    `}
`;

Paragraph.splash = {
    ...TextParagraph.splash,
    defaultProps: {
        ...TextParagraph.splash.defaultProps,
        styles: {
            ...TextParagraph.splash.defaultProps.styles,
            fontSize: 16,
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
            fontFamily: BRAND_LIBRARY_BODY_TEXT,
        },
        meta: {
            ...TextParagraph.splash.defaultProps.meta,
            content: 'Add your text content here',
            visible: true,
        },
    },
};

export default Paragraph;
